import { useEffect, useRef, useState } from 'react';
import './DisclaimerPopup.css';

const DisclaimerPopup = ({
  message,
  position = 'bottom-right',
  intervalMinutes = 2,
  autoCloseSeconds = 15
}) => {
  const [visible, setVisible] = useState(false);

  const intervalRef = useRef(null);
  const hideTimerRef = useRef(null);
  const hasStartedRef = useRef(false); // 🔥 key fix

  useEffect(() => {
    if (hasStartedRef.current) return; // 🔥 prevent double-run
    hasStartedRef.current = true;

    const showPopup = () => {
      setVisible(true);

      clearTimeout(hideTimerRef.current);
      hideTimerRef.current = setTimeout(() => {
        setVisible(false);
      }, autoCloseSeconds * 1000);
    };

    // ✅ show immediately
    showPopup();

    // ✅ repeat interval
    intervalRef.current = setInterval(
      showPopup,
      intervalMinutes * 60 * 1000
    );

    return () => {
      clearInterval(intervalRef.current);
      clearTimeout(hideTimerRef.current);
    };
  }, [intervalMinutes, autoCloseSeconds]);

  const handleClose = () => {
    clearTimeout(hideTimerRef.current);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={`disclaimer-popup ${position}`} role="alert">
      <span>{message}</span>
      <button onClick={handleClose} aria-label="Close disclaimer">
        ✕
      </button>
    </div>
  );
};

export default DisclaimerPopup;
